import moment from 'moment';
import actions from './invoiceDataActions';
import mutations from './invoiceDataMutations';

const state = {
  items: [],
  filter: {
    dateFrom: moment().startOf('M'),
    dateTo: moment().endOf('M')
  },
  current: null
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/invoiceData/index.js